import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, Grid, LL_V_L, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend';
import { exists, resolveContent } from '@nu-art/ts-common';
import { Component_EntityTimestamps } from '../Component_EntityTimestamps/Component_EntityTimestamps.js';
import './Renderer_SearchResult.scss';
export const Renderer_SearchResult = (props) => {
    const renderMain = () => {
        return _jsxs(LL_V_L, { className: 'q-search-result__main', children: [_jsx("div", { className: 'q-search-result__title', children: props.itemLabel }), exists(props.subtitle) && _jsx("div", { className: 'q-search-result__subtitle', children: resolveContent(props.subtitle) }), exists(props.timestamps) && _jsx(Component_EntityTimestamps, { ...props.timestamps }), exists(props.extraContent) && _jsx("div", { className: 'q-search-result__extra-content', children: resolveContent(props.extraContent) })] });
    };
    const className = _className('q-search-result', props.className);
    return _jsxs(Grid, { className: className, style: props.style, onClick: e => {
            e.stopPropagation();
            props.onClickAction?.();
        }, onContextMenu: !props.rightClickActions?.length ? undefined : e => {
            const model = {
                id: 'search-result-context-menu',
                overlayClass: 'search-result-context-menu__overlay',
                modalPos: { x: 1, y: 1 },
                originPos: { x: e.clientX, y: e.clientY },
                content: props.rightClickActions.map((action, _) => _jsx(Button, { className: 'search-result-context-menu-button', onClick: async () => {
                        e.stopPropagation();
                        await action.action();
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    }, children: action.label }, _))
            };
            ModuleFE_MouseInteractivity.showContent(model);
        }, children: [_jsx("div", { className: 'q-search-result__entity-tag', children: props.entityLabel }), renderMain()] });
};
export const SearchResult_BaseRightClickActions = (item) => {
    if (!item)
        return [];
    return [
        { label: 'Copy Item ID', action: () => ModuleFE_Thunderstorm.copyToClipboard(item._id, 'Copied entity id to clipboard') },
        { label: 'Copy Item JSON', action: () => ModuleFE_Thunderstorm.copyToClipboard(JSON.stringify(item), 'Copied entity to clipboard') },
    ];
};
//# sourceMappingURL=Renderer_SearchResult.js.map